import type { AttachmentProps, PreviewType } from "../types";

export const handleAttachment = ({
  settings,
}: {
  settings: AttachmentProps;
}) => {
  let isEmpty = true;
  let url = "";
  let previewType: PreviewType = "icon";
  let fileIcon = "unknown-file";

  if (settings.attachmentType === "link" && settings.linkUrl) {
    isEmpty = false;
    url = settings.linkUrl;

    if (url.startsWith("http://")) url = url.replace("http://", "https://");
    else url = url.startsWith("https://") ? url : `https://${url}`;

    if (url.includes(".pdf")) previewType = "pdf";
    else if (url.includes("docs.google")) {
      if (url.includes("/document/")) fileIcon = "google-docs";
      else if (url.includes("/spreadsheets/")) fileIcon = "google-sheets";
      else if (url.includes("/presentation/")) fileIcon = "google-slides";
    } else if (url.includes("drv.ms")) {
      if (url.includes("/w/")) fileIcon = "microsoft-word";
      else if (url.includes("/x/")) fileIcon = "microsoft-excel";
      else if (url.includes("/p/")) fileIcon = "powerpoint";
    }
  } else if (
    settings.attachmentType === "file" &&
    settings.fileUrl &&
    settings.fileType
  ) {
    isEmpty = false;
    url = settings.fileUrl;
    if (url.includes(".pdf")) previewType = "pdf";
    else if (settings.fileType.includes("officedocument")) {
      if (settings.fileUrl.includes(".ppt")) fileIcon = "powerpoint";
      else if (settings.fileUrl.includes(".doc")) fileIcon = "microsoft-word";
      else if (settings.fileUrl.includes(".xls")) fileIcon = "microsoft-excel";
    }
  }

  if (previewType === "pdf" && url) {
    const u = new URL(url);
    u.hash = "view=FitH&toolbar=0&navpanes=0&scrollbar=0";
    url = u.toString();
  }

  return { isEmpty, url, previewType, fileIcon };
};
